<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
<footer class="footer py-5">
  <div class="mb-3">
    <img class="mx-auto d-block" src="{image(block, 'logo', [null, 50])}" alt="">
  </div>
  <div class="container">
    <div class="row mb-3">
      <div class="col-md-4 col-6 mb-md-0 mb-4">
        <!-- empty -->
      </div>

      <div class="col-md-2 col-6 mb-md-0 mb-4">
        <h6 class="text-sm">Apie mus</h6>
        <ul class="flex-column ms-n3 nav">
          {#each blocklist(block, 'about') as item}
          <li class="nav-item">
            <a class="nav-link text-secondary" href="{url(item, 'link')}" target="_blank">
              {text(item, 'link')}
            </a>
          </li>
          {/each}
        </ul>
      </div>

      <div class="col-md-2 col-6 mb-md-0 mb-4">
        <h6 class="text-sm">Aktualu</h6>
        <ul class="flex-column ms-n3 nav">
          {#each blocklist(block, 'latest') as item}
          <li class="nav-item">
            <a class="nav-link text-secondary" href="{url(item, 'link')}" target="_blank">
              {text(item, 'link')}
            </a>
          </li>
          {/each}
        </ul>
      </div>

      <div class="col-md-2 col-6 mb-md-0 mb-4">
        <h6 class="text-sm">Įmonės rekvizitai</h6>
        <ul class="flex-column ms-n3 nav">
          {#each blocklist(block, 'contacts') as item}
          <li class="nav-item">
            <div class="nav-link">
              {@html richtext(item, 'contact')}
            </div>
          </li>
          {/each}
        </ul>
      </div>

    </div>
    
    <div class="row">
      {#each blocklist(block, 'social') as item}
      <div class="col-lg-8 mx-auto text-center mb-4 mt-2">
        <a href="{url(item, 'link')}" target="_blank" class="text-secondary me-xl-4 me-4">
          <img src="{image(item, 'icon', [50, 50])}" alt="{text(item, 'link')}">
        </a>
      </div>
      {/each}
    </div>
    <hr class="horizontal dark">
    <div class="row">
      <div class="col-8 mx-auto text-center mt-1">
        <p class="mb-0 text-secondary">
          <span class="">© All rights reserved. Made by</span>
          <a class="small nav-link-style nav-link-light" href="https://keycommunication.lt" target="_blank" rel="noopener">key | communication</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!-- -------- END FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
